import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import "./candidate.css";
import Spinner from 'components/Spinner';
import { getScreeningsByCandidate, createScreeningDetails, updateScreeningDetails, getActiveProgramList } from "../../lib/axiosUtils";
import ShowToast from 'components/ShowToast';
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from "assets/constants/Constants";
import { toCapitaliseWord } from 'lib/utils';
import DatePicker from "react-datepicker";

const ScreeningDetail = (props) => {
    const [screeningId, setScreeningId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const userDetails = JSON.parse(localStorage.getItem("userData"));
    const [candidateId] = useState(props.location.state?.candidateId);
    const [partnerId] = useState(props.location.state?.partnerId);
    const [engagementType] = useState(props.location.state?.engagementType);
    const [fullName] = useState(props.location.state?.fullName);
    const [projectOptions, setProjectOptions] = useState([]);
    const [formData, setFormData] = useState({
        screening_date: new Date().toISOString().split("T")[0],
        screener_id: userDetails._id,
        screener_name: `${userDetails.first_name} ${userDetails.last_name}`,
        partner_id: partnerId,
        engagement_type: engagementType,
        grooming_score: "",
        confidence_score: "",
        communication_score: "",
        knowledge_score: "",
        acceptance_to_relocate: "",
        screener_notes: "",
        screening_status: "",
        assigned_project_id: ""
    });
    const [disabledButtons, setDisabledButtons] = useState(false);
    const [candidateData, setCandidateData] = useState([]);

    const scoreOptions = [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' },
        { value: '10', label: '10' }
    ];

    const yesNoOptions = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' }
    ];

    useEffect(() => {
        if (!candidateId) return;
        const fetchScreeningDetails = async () => {
            try {
                setIsLoading(true);
                const screenData = await getScreeningsByCandidate({}, {}, candidateId);

                console.log("screenData:", screenData);

                const screeningList = screenData?.data?.result.screenings || [];
                const candidateData = screenData?.data?.result.candidate || [];

                setCandidateData(candidateData);

                if (screeningList.length > 0) {
                    const screening = screeningList[0];
                    if (screening.screening_status === "Selected") {
                        setDisabledButtons(true);
                    }

                    setScreeningId(screening._id);
                    console.log("screening._id:", screening._id);

                    setFormData({
                        screening_date: screening.screening_date ? new Date(screening.screening_date).toISOString().split("T")[0] : formData.screening_date,
                        screener_id: screening.screener_id || "",
                        screener_name: screening.screener_name ? screening.screener_name : formData.screener_name,
                        grooming_score: screening.grooming_score || "",
                        confidence_score: screening.confidence_score || "",
                        communication_score: screening.communication_score || "",
                        knowledge_score: screening.knowledge_score || "",
                        acceptance_to_relocate: screening.acceptance_to_relocate || "",
                        screener_notes: screening.screener_notes || "",
                        screening_status: screening.screening_status || "",
                        assigned_project_id: screening.assigned_project_id || ""
                    });
                }

            } catch (error) {
                console.error("Fetch Screening Details Error:", error);
            } finally {
                setIsLoading(false);
            }
        };

        const getAllprojectList = async () => {
            const programList = await getActiveProgramList({}, {});
            // if (programList.data.statusCode === 200) {
            const programs = programList?.data?.result || [];
            setProjectOptions(
                programs.map((program) => ({
                    label: program.program_name,
                    value: program._id
                }))
            );
            // }
        }

        fetchScreeningDetails();
        getAllprojectList();

        // eslint-disable-next-line
    }, [candidateId]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSelectChange = (selectedOption, fieldName) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: selectedOption
                ? selectedOption.value
                : ""
        }));
    };

    const createScreeningHandler = async (e) => {
        e.preventDefault();

        try {
            setIsLoading(true);
            const payload = {
                candidate_id: candidateId,
                screening_date: new Date().toISOString().split("T")[0],
                screener_id: userDetails._id,
                partner_id: partnerId ? partnerId : null,
                grooming_score: Number(formData.grooming_score),
                confidence_score: Number(formData.confidence_score),
                communication_score: Number(formData.communication_score),
                knowledge_score: Number(formData.knowledge_score),
                acceptance_to_relocate: formData.acceptance_to_relocate,
                screener_notes: formData.screener_notes,
                screening_status: formData.screening_status,
                assigned_project_id: formData.assigned_project_id || null,
                engagement_type: engagementType ? engagementType : ""
            };
            console.log("payload:", payload);
            let response;

            if (screeningId) {
                // Update existing screening
                response = await updateScreeningDetails({}, payload, screeningId);
                console.log("response c:", response);
                ShowToast('Screening data updated Successfully', TYPE_SUCCESS, INTERVAL, props, "/tjp-screening-queue");
            } else {
                response = await createScreeningDetails({}, payload);
                console.log("response u:", response);
                ShowToast('Screening data created Successfully', TYPE_SUCCESS, INTERVAL, props, "/tjp-screening-queue");
            }
        } catch (error) {
            console.error("Screening Submit Error:", error);
            ShowToast('Screening Submit Error, Please try again', TYPE_FAIL, INTERVAL, "", "");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {
                isLoading ? (
                    <Spinner />
                ) : (
                    <div className="main-content">
                        <div className="back">
                            <ul className="breadcrumb1">
                                <li><a href="/tjp-screening-queue">Screening queue</a></li>
                                <li>Screening detail - {fullName} </li>
                            </ul>
                        </div>
                        <div className="add-user-wrapper">
                            <div className="mx-auto text-left border create-user-div">
                                <form onSubmit={createScreeningHandler} className="pt-1">
                                    <div className="screening-details-div">
                                        <label className="screening-line-div">Candidate's Details</label>
                                        <div className="screening-section-div"></div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Engagement type </label>
                                            <Select
                                                name="engagementType"
                                                placeholder={"Select Engagement Type"}
                                                value={{
                                                    label: candidateData?.engagement_type,
                                                    value: candidateData?.engagement_type
                                                }}
                                                isDisabled={true}
                                            />
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Training Partner </label>
                                            <Select
                                                name="trainingPartner"
                                                placeholder={"Select Training Partner"}
                                                value={{
                                                    label: candidateData?.training_partner,
                                                    value: candidateData?.training_partner
                                                }}
                                                isDisabled={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">First Name </label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input" defaultValue={candidateData?.first_name} readOnly />
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Last Name </label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input" defaultValue={candidateData?.last_name} readOnly />
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Father Name </label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input" defaultValue={candidateData?.fathers_name} readOnly />
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Gender </label>
                                            <Select
                                                name="gender"
                                                placeholder={"Select Gender"}
                                                value={{
                                                    label: candidateData?.gender && toCapitaliseWord(candidateData?.gender),
                                                    value: candidateData?.gender
                                                }}
                                                isDisabled={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Date of Birth</label>
                                            <DatePicker
                                                className="form-control brand-font p-3 placeholderColor add-user-input"
                                                selected={
                                                    candidateData?.date_of_birth
                                                        ? new Date(candidateData.date_of_birth)
                                                        : null
                                                }
                                                onChange={(date) => {
                                                    console.log("Selected DOB:", date);
                                                }}
                                                placeholderText="Select Date of Birth"
                                                dateFormat="dd/MM/yyyy"
                                                disabled={true}
                                            />

                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Age </label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input" defaultValue={candidateData?.age} readOnly />
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Highest Qualification </label>
                                            <Select
                                                name="qualification"
                                                placeholder={"Select Qualification"}
                                                defaultValue={candidateData?.qualification}
                                                value={{
                                                    label: candidateData?.qualification,
                                                    value: candidateData?.qualification
                                                }}
                                                isDisabled={true}
                                            />
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Year of Qualification </label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input" defaultValue={candidateData?.passing_year} readOnly />
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6 email-input">
                                            <label className="form-label">Email </label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input" defaultValue={candidateData?.email} readOnly />
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Mobile </label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input" defaultValue={candidateData?.mobile_no} readOnly />
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Aadhar Number </label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input" defaultValue={candidateData?.adhaar_no} readOnly />
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Select State </label>
                                            <Select
                                                name="state"
                                                placeholder={"Select State"}
                                                value={{
                                                    label: candidateData?.state,
                                                    value: candidateData?.state
                                                }}
                                                isDisabled={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Select Candidate Home city </label>
                                            <Select
                                                name="city"
                                                placeholder={"Select City"}
                                                value={{
                                                    label: candidateData?.city,
                                                    value: candidateData?.city
                                                }}
                                                isDisabled={true}
                                            />
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Primary occupation of the earning parent </label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input" type="text" defaultValue={candidateData?.parent_occupation} readOnly />
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Annual household income </label>
                                            <input className="form-control brand-font p-3 placeholderColor add-user-input" type="text" defaultValue={candidateData?.annual_income} readOnly />
                                        </div>
                                    </div>
                                    <div className="screening-details-div">
                                        <label className="screening-line-div">Screening Details</label>
                                        <div className="screening-section-div"></div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Date of screening </label>
                                            <input
                                                type="date"
                                                name="screening_date"
                                                value={formData.screening_date}
                                                className="form-control brand-font p-3 placeholderColor add-user-input"
                                                readOnly
                                            />
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Screener</label>
                                            <input
                                                type="text"
                                                name="screener_name"
                                                value={formData.screener_name}
                                                className="form-control brand-font p-3 placeholderColor add-user-input"
                                                placeholder="Screener Name"
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">Grooming</label>
                                            <Select
                                                className="add-user-input-height"
                                                placeholder="Select Score"
                                                options={scoreOptions}
                                                value={
                                                    scoreOptions.find(
                                                        (option) =>
                                                            option.value ===
                                                            String(formData.grooming_score)
                                                    ) || null
                                                }
                                                onChange={(selectedOption) =>
                                                    handleSelectChange(
                                                        selectedOption,
                                                        "grooming_score"
                                                    )
                                                }
                                            />

                                        </div>
                                        <div className="input-label-group col-md-6 email-input">
                                            <label className="form-label">Confidence</label>
                                            <Select
                                                className="add-user-input-height"
                                                placeholder="Select Score"
                                                options={scoreOptions}
                                                value={
                                                    scoreOptions.find(
                                                        (option) =>
                                                            option.value ===
                                                            String(formData.confidence_score)
                                                    ) || null
                                                }
                                                onChange={(selectedOption) =>
                                                    handleSelectChange(
                                                        selectedOption,
                                                        "confidence_score"
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-0">
                                        <div className="col-md-6">
                                            <label className="form-label">Communication skills</label>
                                            <Select
                                                className="add-user-input-height"
                                                placeholder="Select Score"
                                                options={scoreOptions}
                                                value={
                                                    scoreOptions.find(
                                                        (option) =>
                                                            option.value ===
                                                            String(formData.communication_score)
                                                    ) || null
                                                }
                                                onChange={(selectedOption) =>
                                                    handleSelectChange(
                                                        selectedOption,
                                                        "communication_score"
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Knowledge</label>
                                            <Select
                                                className="add-user-input-height"
                                                placeholder="Select Score"
                                                options={scoreOptions}
                                                value={
                                                    scoreOptions.find(
                                                        (option) =>
                                                            option.value ===
                                                            String(formData.knowledge_score)
                                                    ) || null
                                                }
                                                onChange={(selectedOption) =>
                                                    handleSelectChange(
                                                        selectedOption,
                                                        "knowledge_score"
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-0 mt-4">
                                        <div className="col-md-6">
                                            <label className="form-label">Acceptance to relocate</label>
                                            <div className="form-wrap-inner">
                                                <Select
                                                    placeholder="Select Yes/No"
                                                    options={yesNoOptions}
                                                    value={
                                                        yesNoOptions.find(
                                                            (option) =>
                                                                option.value ===
                                                                formData.acceptance_to_relocate
                                                        ) || null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        handleSelectChange(
                                                            selectedOption,
                                                            "acceptance_to_relocate"
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row mt-0 mt-4">
                                        <div className="col-md-12">
                                            <div className="form-wrap">
                                                <label className="form-label">Screener notes</label>
                                                <input
                                                    name="screener_notes"
                                                    value={formData.screener_notes}
                                                    onChange={handleInputChange}
                                                    className="form-control brand-font p-3 placeholderColor add-user-input"
                                                    placeholder="Free-text observations"
                                                />
                                            </div>

                                        </div>
                                    </div>
                                    <div className="row mt-0 mt-4 mb-5 display-inline">
                                        <div className="form-button-div-screening">

                                            <button
                                                type="button"
                                                disabled={disabledButtons}
                                                className={
                                                    formData.screening_status === "Selected"
                                                        ? "brand-button"
                                                        : "cancel_button"
                                                }
                                                onClick={() =>
                                                    setFormData((prevData) => ({
                                                        ...prevData,
                                                        screening_status: "Selected"
                                                    }))
                                                }
                                            >
                                                Selected
                                            </button>

                                            <button
                                                type="button"
                                                disabled={disabledButtons}
                                                className={
                                                    formData.screening_status === "Not selected"
                                                        ? "brand-button ml-5"
                                                        : "cancel_button ml-5"
                                                }
                                                onClick={() =>
                                                    setFormData((prevData) => ({
                                                        ...prevData,
                                                        screening_status: "Not selected",
                                                        assigned_project_id: ""
                                                    }))
                                                }
                                            >
                                                Not Selected
                                            </button>
                                        </div>
                                    </div>
                                    {formData.screening_status === "Selected" && (
                                        <div className="row mt-4">
                                            <div className="col-md-6">
                                                <label>Assign Project</label>
                                                <Select
                                                    name="assigned_project_id"
                                                    options={projectOptions}
                                                    isDisabled={disabledButtons}
                                                    value={
                                                        projectOptions.find(
                                                            (option) =>
                                                                option.value === formData.assigned_project_id
                                                        ) || null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        handleSelectChange(
                                                            selectedOption,
                                                            "assigned_project_id"
                                                        )
                                                    }
                                                    placeholder="Select Project"
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="row mt-4 mb-4">
                                        <div className="col-md-12">
                                            <button
                                                type="submit"
                                                className="brand-button"
                                                disabled={isLoading}
                                            >
                                                {isLoading
                                                    ? "Saving..."
                                                    : screeningId
                                                        ? "Update"
                                                        : "Save"}
                                            </button>
                                        </div>
                                    </div>
                                    {/* <button className="brand-button" onClick={createUserHandler}>{userId ? "Update" : "Create"}</button>
                                            <button className="cancel_button ml-5" onClick={cancelHandler}>Cancel</button> */}
                                </form>
                            </div>
                        </div>
                        <div className="row dummy_row"></div>
                    </div>
                )
            }
        </>
    );
};

export default ScreeningDetail;